const environment = REACT_APP_ENV || 'local';
const gooleMapsClientAPIKey = GOOGLE_MAPS_CLIENT_API_KEY || '';

interface Config {
  API_BASE_URL: string;
  API_REDBOOK_BRANDS_URL: string;
  API_REDBOOK_MODELS_URL: string;
  API_REDBOOK_MODEL_YEARS_URL: string;
  API_REDBOOK_VARIENTS_URL: string;
  API_REDBOOK_SPECIFICATION_URL: string;
  API_REDBOOK_REGO_DETAILS_URL: string;
  API_VW_LOCALITY_SEARCH_URL: string;
  API_SALESFORCE_SURVEY_URL: string;
  EV_FIT_ASSETS_BASE_URL: string;
  AMPOL_AMP_CHARGE_ASSETS_BASE_URL: string;
  API_DATA_TOOLS_EMAIL_VALIDATOR_URL: string;
  API_DATA_TOOLS_PHONE_NUMBER_VALIDATOR_URL: string;
  GOOGLE_MAPS_CLIENT_API_KEY: string;
  API_PLUGSHARE_POIS_SEARCH: string;
  API_EV_MAP_LOOK_UP_BY_LAT_LNG_URL: string;
  API_EV_MAP_LOOK_UP_BY_POST_CODE_URL: string;
  API_EV_CHAT_PROMPTS: string;
  API_VW_CELEBRATION_GPS_DATA: string;
  API_VW_CELEBRATION_POSITION_DETAIL: string;
  API_VW_CELEBRATION_EVENT_STATISTIC: string;
  EVMAP_ENABLED: boolean;
  AMBIT_URL: string;
  AMBIT_SECRET: string;
}

const generateEnvironmentConfig = (
  baseUrl: string,
  assetsBaseUrl = 'https://static-stg.volkswagen.com.au/website',
  evMapEnabled = false,
  ambitUrl = 'https://volkswagen.clientdev.ambithub.com',
  ambitSecret = 'yourSecretHere', // secret is not needed at all
): Config => ({
  API_BASE_URL: baseUrl,
  API_REDBOOK_BRANDS_URL: `${baseUrl}/api/redbook/brands`,
  API_REDBOOK_MODELS_URL: `${baseUrl}/api/redbook/models`,
  API_REDBOOK_MODEL_YEARS_URL: `${baseUrl}/api/redbook/model-years`,
  API_REDBOOK_VARIENTS_URL: `${baseUrl}/api/redbook/varients`,
  API_REDBOOK_SPECIFICATION_URL: `${baseUrl}/api/redbook/specification`,
  API_REDBOOK_REGO_DETAILS_URL: `${baseUrl}/api/redbook/rego-details`,
  API_VW_LOCALITY_SEARCH_URL: `${baseUrl}/api/vw/locality-search`,
  API_SALESFORCE_SURVEY_URL: `${baseUrl}/api/salesforce/ev-survey`,
  API_DATA_TOOLS_EMAIL_VALIDATOR_URL: `${baseUrl}/api/datatools/validate-email`,
  API_DATA_TOOLS_PHONE_NUMBER_VALIDATOR_URL: `${baseUrl}/api/datatools/validate-phone-number`,
  EV_FIT_ASSETS_BASE_URL: `${assetsBaseUrl}/ev-fit/assets/`,
  AMPOL_AMP_CHARGE_ASSETS_BASE_URL: `${assetsBaseUrl}/ampol-amp-charge/assets/`,
  API_PLUGSHARE_POIS_SEARCH: `${baseUrl}/api/plugshare/pois/search`,
  GOOGLE_MAPS_CLIENT_API_KEY: gooleMapsClientAPIKey,
  API_EV_MAP_LOOK_UP_BY_LAT_LNG_URL: `${baseUrl}/api/ev-map/lookup-by-latlng`,
  API_EV_MAP_LOOK_UP_BY_POST_CODE_URL: `${baseUrl}/api/ev-map/lookup-by-postcode`,
  API_EV_CHAT_PROMPTS: `${baseUrl}/api/ev-chat/prompts`,
  API_VW_CELEBRATION_GPS_DATA: `${baseUrl}/api/vw/gps-tour/get-positions`,
  API_VW_CELEBRATION_EVENT_STATISTIC: `${baseUrl}/api/vw/gps-tour/event-statistic`,
  API_VW_CELEBRATION_POSITION_DETAIL: `${baseUrl}/api/vw/gps-tour/get-position-detail`,
  EVMAP_ENABLED: evMapEnabled,
  AMBIT_URL: ambitUrl,
  AMBIT_SECRET: ambitSecret,
});

const environmentConfigs: Record<string, Config> = {
  local: generateEnvironmentConfig('http://localhost:3001'),
  develop: generateEnvironmentConfig(
    'https://develop-vw-client-api.vercel.app',
    'https://static-stg.volkswagen.com.au/website',
    true,
  ),
  staging: generateEnvironmentConfig(
    'https://api-stg.volkswagen.com.au',
    'https://static-stg.volkswagen.com.au/website',
    true,
    'https://volkswagen.ambithub.com',
  ),
  production: generateEnvironmentConfig(
    'https://api.volkswagen.com.au',
    'https://static.volkswagen.com.au/website',
    true,
    'https://volkswagen.ambithub.com',
  ),
};

export const config =
  environmentConfigs[environment] ?? environmentConfigs.develop;
